import React, {useEffect, useState} from 'react';
import './App.css';

import Explorer from './components/explorer/explorer'
import Steps from "./components/steps/steps";
import Instructions from "./components/instructions/instructions";
import FloContext from "./components/contexts/floContext";
import {getSteps, getFilesAndFolders} from "./components/utils/floServices";
import ExtensionPopup from "./components/popups/extensionPopup";

export default function HowTo() {
   let [collapse, setCollapse] = useState(false);
   const [steps, setSteps] = useState([{}] as any[]);
   const [filesAndFolders, setFilesAndFolders] = useState([] as any[]);
   const [selectedToEditFolder, setSelectedToEditFolder] = useState({id: null});
   const [selectedFile, setSelectedFile] = useState({id: null});
   const [selectedToEditFile, setSelectedToEditFile] = useState({id: null});

   const originalSteps: React.MutableRefObject<any> = React.useRef([]);
   const originalFilesAndFolders: React.MutableRefObject<any> = React.useRef([]);

   let draggedFolder: React.MutableRefObject<any> = React.useRef({});
   let droppedFolder: React.MutableRefObject<any> = React.useRef({});
   let draggedFile: React.MutableRefObject<any> = React.useRef({});


   // ..... Context Date .......
   const contextData = {
      filesAndFolders,
      steps,
      draggedFolder,
      droppedFolder,
      selectedToEditFolder,
      draggedFile,
      selectedFile,
      selectedToEditFile,
      onAddFolder: addFolder,
      onEnableFolderEdit: enableFolderEdit,
      onFolderRename: renameFolder,
      onFolderDelete: deleteFolder,
      onDragging: handleDragging,
      onDropping: handleDropping,
      onDropped: handleDropped,
      onSort: handleSort,
      onFileDelete: deleteFile,
      onFileSelect: selectFile,
      onEnableFileEdit: enableFileEdit,
      onFileSelectToEdit: selectFile,
      onFileRename: renameFile,
      onInstructionEdit: editInstruction,
      onNewInstruction: addNewInstruction,
      onDeleteInstruction: deleteInstruction,
   }


   // ..... manage add folder .......
   function addFolder() {
      const copiedFolders = [...originalFilesAndFolders.current];
      copiedFolders.splice(0, 0, {
         name: 'Untitled folder',
         _id: copiedFolders.length + 1,
         files: []
      })
      setFilesAndFolders(copiedFolders);
      originalFilesAndFolders.current = copiedFolders;
   }

   // ..... manage delete folder .......
   function deleteFolder(folder: any) {
      const copiedFolders = [...originalFilesAndFolders.current];
      const folders = copiedFolders.filter((f) => {
         return f._id !== folder._id;
      })
      setFilesAndFolders(folders);
      originalFilesAndFolders.current = folders;
   }

   // ..... enable folder edit .......
   function enableFolderEdit(folder: any) {
      setSelectedToEditFolder(folder);
   }

   // ..... rename folder .......
   function renameFolder(folder: any, folderName: string) {
      setSelectedToEditFolder({id: null});
      const folders = [...originalFilesAndFolders.current];
      const folderIndex = folders.indexOf(folder);
      folders[folderIndex].name = folderName;
      setFilesAndFolders(folders);
      originalFilesAndFolders.current = folders;
   }

   // ..... Manage file dragging .......
   function handleDragging(folder: any, file: any) {
      draggedFolder.current = folder;
      draggedFile.current = file;
   }

   // ..... Manage file dropping .......
   function handleDropping(folder: any) {
      droppedFolder.current = folder;
   }

   // ..... Manage file dropped .......
   function handleDropped() {
      const {_id: draggedFolderId} = draggedFolder.current;
      const {_id: droppedFolderId} = droppedFolder.current;

      if (draggedFolderId !== droppedFolderId) {
         const folders = moveFile(
             draggedFolder.current,
             droppedFolder.current,
             draggedFile.current)

         setFilesAndFolders(folders);
      }
   }

   // ..... Manage move file .......
   function moveFile(from: any, to: any, file: any) {
      const folders = [...originalFilesAndFolders.current];
      const fromFolderIndex = folders.indexOf(from);
      const toFolderIndex = folders.indexOf(to);
      const fileToMoveIndex = (folders[fromFolderIndex].files).indexOf(file);

      (folders[fromFolderIndex].files).splice(fileToMoveIndex, 1);
      (folders[toFolderIndex].files).splice(0, 0, file);

      return folders;
   }

   // ..... delete file .......
   function deleteFile(folder: any, file: any) {
      const folders = [...originalFilesAndFolders.current];
      const folderIndex = folders.indexOf(folder);
      const copiedFolder = {...folders[folderIndex]};
      folders[folderIndex].files = (copiedFolder.files).filter((f: any) => {
         return f._id !== file._id;
      })
      setFilesAndFolders(folders);
      originalFilesAndFolders.current = folders;
   }

   // ..... select file .......
   function selectFile(folder: any, file: any) {
      setSelectedFile(file);
   }

   // ..... enable file edit .......
   function enableFileEdit(folder: any, file: any) {
      setSelectedToEditFile(file);
   }

   // ..... select file .......
   function renameFile(folder: any, file: any, filename: string) {
      setSelectedToEditFile({id: null});
      const folders = [...originalFilesAndFolders.current];
      const folderIndex = folders.indexOf(folder);
      const files = folders[folderIndex].files;
      const fileIndex = files.indexOf(file);

      folders[folderIndex].files[fileIndex].name = filename;
      setFilesAndFolders(folders);
      originalFilesAndFolders.current = folders;
   }

   // ..... Add new instruction .......
   function addNewInstruction(step: any) {
      const allSteps = [...originalSteps.current];
      const stepIndex = allSteps.indexOf(step);
      const newStep = {
         _id: allSteps.length + 1,
         content: null
      }
      allSteps.splice(stepIndex + 1, 0, newStep);
      setSteps(allSteps);
      originalSteps.current = allSteps;
   }

   // ..... delete new instruction .......
   function deleteInstruction(step: any) {
      const steps = (originalSteps.current).filter((s: any) => {
         return s._id !== step._id;
      });
      setSteps(steps);
      originalSteps.current = steps;
   }

   // ..... Edit  instruction .......
   function editInstruction(step: any, rowData: any) {
      const steps = [...originalSteps.current];
      const indexStepToUpdate = steps.indexOf(step);
      if (step && step.hasOwnProperty('content')) {
         if (JSON.stringify(step.content) !== JSON.stringify(rowData)) {
            steps[indexStepToUpdate].content = rowData;
            setSteps(steps);
            originalSteps.current = steps;
         }
      }
   }


   // ..... Manage steps sort .......
   function handleSort(order: any[], stepsList: any[]) {
      const newOrder: any[] = [];
      for (const index of order) {
         newOrder.push(originalSteps.current[index]);
      }
      setSteps(newOrder);
      originalSteps.current = newOrder;
   }

   // ...... Manage nav collapse .........
   function manageNavCollapse() {
      collapse = !collapse;
      setCollapse(collapse);
   }

   // ...... Assign data .........
   useEffect(() => {
      originalSteps.current = getSteps();
      originalFilesAndFolders.current = getFilesAndFolders();

      setSteps(originalSteps.current);
      setFilesAndFolders(originalFilesAndFolders.current);
   }, []);

   return (
       <FloContext.Provider
           value={contextData}>
          <div className={'create-instructions flex align-top ' + (collapse ? 'collapse-nav' : '')}>
             {/*......... explorer ............*/}
             <Explorer onCollapse={manageNavCollapse}/>

             <div className="instruction-wrapper flex align-top">
                {/*........... instructions ............*/}
                <Instructions/>

                {/*........... steps ............*/}
                <Steps/>
             </div>

             <ExtensionPopup/>

          </div>
       </FloContext.Provider>
   )
}

